import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://72dca53b0b2a05ab6cbc7add864ec1a8@o4511335665631232.ingest.us.sentry.io/4511335670677504",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});